<template>
  <div class="question">
    <div class="inner">
      <el-form
        label-position="left"
        label-width="100px"
        :model="form"
        :rules="rules"
        :hide-required-asterisk="true"
        ref="form"
      >
        <el-form-item :label="$t('分類')" prop="question_type">
          <el-select v-model="form.question_type" placeholder="">
            <el-option
              v-for="item in options"
              :key="item.type"
              :label="item.label"
              :value="item.type"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('主題')"
          prop="article.title"
          :rules="{
            required: true,
            message: this.$t('請輸入主題'),
            trigger: 'blur',
          }"
        >
          <el-input
            v-model="form.article.title"
            :placeholder="$t('請輸入文章主題')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('伺服器')" prop="server">
          <el-select v-model="form.server" placeholder="">
            <el-option
              v-for="item in serves"
              :key="item.type"
              :label="item.label"
              :value="item.type"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('角色')" prop="role">
          <el-input
            v-model="form.role"
            :placeholder="$t('請輸入角色')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <vue-editor
            useCustomImageHandler
            @image-added="handleImageAdded"
            v-model="form.article.content"
          ></vue-editor>
          <div class="error-message" v-if="showError">
            {{ $t("请输入关键字") }}
          </div>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button @click="cancle">{{ this.$t("取消") }}</el-button>
        <el-button type="primary" @click="submit">{{
          this.$t("確認")
        }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import { addQuestion, getQuestionDetail, editQuestion } from "@/api/serve";
export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      form: {
        article: {},
        server: 1,
      },
      rules: {
        question_type: [
          { required: true, message: this.$t("請選擇分類"), trigger: "change" },
        ],
        role: [
          { required: true, message: this.$t("請輸入角色"), trigger: "blur" },
        ],
      },
      options: [
        {
          label: this.$t("會員資料"),
          type: 1,
        },
        {
          label: this.$t("遊戲使用"),
          type: 2,
        },
        {
          label: this.$t("安裝/執行"),
          type: 3,
        },
        {
          label: this.$t("儲值"),
          type: 4,
        },
        {
          label: this.$t("運營"),
          type: 5,
        },
        {
          label: this.$t("檢舉"),
          type: 6,
        },
        {
          label: this.$t("其他"),
          type: 100,
        },
      ],
      showError: false,
      serves: [
        {
          label: this.$t("全服通用"),
          type: 1,
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("getUser");
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    async getDetail() {
      const res = await getQuestionDetail({ id: this.$route.query.id });
      this.form = {
        ...res.data,
      };
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.form.article.content) {
            if (this.$route.query.id) {
              const res = await editQuestion(this.form);
              this.$router.push(`/questionEdit?id=${res.data.id}`);
            } else {
              const res = await addQuestion(this.form);
              if (res.status === 201) {
                this.$message.success(this.$t("發送成功"));
                this.$router.push(`/questionEdit?id=${res.data.id}`);
              }
            }
          } else {
            this.showError = true;
          }
        }
      });
    },
    cancle() {
      this.$router.back();
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      let _this = this;
      var formData = new FormData();
      formData.append("file", file);
      fetch(this.$baseUrl + "/1/communities/upload/", {
        method: "POST",
        body: formData,
      })
        .then((data) => {
          return data.json();
        })
        .then((ret) => {
          if (ret.url) {
            let url = ret.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "image", url);
            resetUploader();
          } else if (ret.detail)
            _this.$message({
              message: ret.detail,
              type: "success",
              offset: "100",
            });
          else
            _this.$message({
              message: _this.$t("上載失敗"),
              type: "error",
              offset: "100",
            });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.question {
  width: 100%;
  min-height: 80vh;
  text-align: left;
  background-image: url("~@/assets/img/home/bg_currency.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  .inner {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 40px 0;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
    }
  }
}
</style>
